/* 此文件仅可以扩展 请勿修改已有接口 */
const services = {
  myHandle: 'mediacloud-article-my/myHandle', // 我的稿库
  adStart: 'mediacloud-release-end/MediaCloudReleaseEnd-ADStart',
  recommendation: 'mediacloud-release-end/MediaCloudReleaseEnd-Recommendation',
  dep: 'mediacloud-article-edit', // 部门库
  origin: 'mediacloud-article-origin', // 稿源库
  audit: 'mediacloud-article-audit', // 审稿库
  notice: 'mediacloud-article-my/NoticeAdd', // 公告管理，新建公告
  my: 'mediacloud-article-my', // 我的稿库
  app: 'mediacloud-publish-center/MediaCloudPublishCenter-App', // app发布库
  web: 'mediacloud-publish-center/MediaCloudPublishCenter-Web', // web发布库
  paper: 'mediacloud-paper', // 报纸小样
  journal: 'mediacloud-journal', // 期刊
  tv: 'mediacloud-article-wx/article-tv', // 电视文稿
  weibo: 'mediacloud-article-wx/article-wb', //微博
  wx: 'mediacloud-article-wx', // 微信
  others: 'mediacloud-article-video/article-others', // 媒体号
  videos: 'mediacloud-article-video', // 视频号
  articleWire: 'mediacloud-wire/article-wire', // 新华社稿库
  photoWire: 'mediacloud-wire/photo-wire', // 新华社图片
  nisSet: 'mediacloud-release-end/qa', // 写了个bug /qa要在在前面
  nisApplet: 'mediacloud-release-end/nis-applet', // 小程序平台
  discussSet: 'mediacloud-release-end/discuss', //评论管理
  appSet: 'mediacloud-release-end',
  planning: 'mediacloud-newsplan', // 选题策划
  nis: 'mediacloud-nis', // 社圈
  video: 'mediacloud-mam/MediaCloudMam-Video', // 视频库
  audio: 'mediacloud-mam/MediaCloudMam-Audio', // 音频库
  otherchannel: 'mediacloud-system/MediaCloudSystem-Tripartite', //三方系统渠道
  instruct: 'mediacloud-rr-instruct', // 云端稿库-指令下达
  jointPlanning: 'mediacloud-rr-jointPlanning', // 云端稿库-联合规划
  cloud: 'mediacloud-distinct', // 云端稿库
  photo: 'resource-center-photos/ImgLibraryList', // 图片库
  systemMessages: 'mediacloud-article-my/systemMessages', // 系统消息
  mediaxBatman: 'mediacloud-reporter', // PUGC投稿平台-作品管理
  rrLog: 'mediacloud-rr-log', // 云端稿库-日志审计
  rcpaper: 'rc-paper', //见报
  proSource: 'mediacloud-production-source/', // 生产库资产库
  assetArticle: 'mediacloud-production-source/' // 资产稿库
}
/* 详情页及其他 */
const servicesCommonKeyWord = {
  dep: 'mediacloud-article-edit/',
  origin: 'mediacloud-article-origin/',
  audit: 'mediacloud-article-audit/',
  my: 'mediacloud-article-my/',
  app: 'mediacloud-publish-center/MediaCloudPublishCenter-App-',
  web: 'mediacloud-publish-center/MediaCloudPublishCenter-Web-',
  paper: 'mediacloud-paper/',
  journal: 'mediacloud-journal/', // 期刊
  tv: 'mediacloud-article-wx/',
  wx: 'mediacloud-article-wx/',
  weibo: 'mediacloud-article-wx/',
  others: 'mediacloud-article-video/article-others/', // 媒体号
  videos: 'mediacloud-article-video/', // 视频号
  planning: 'mediacloud-newsplan/', // 选题策划
  proSource: 'mediacloud-production-source/',
  assetArticle: 'mediacloud-production-source/' // 资产稿库
}
/* 新建和编辑页面 */
const servicesOpenKeyWord = {
  dep: 'mediacloud-article-edit/',
  origin: 'mediacloud-article-origin/',
  audit: 'mediacloud-article-audit/',
  my: 'mediacloud-article-my/',
  app: 'mediacloud-publish-center/MediaCloudPublishCenter-App-',
  web: 'mediacloud-publish-center/MediaCloudPublishCenter-Web-',
  paper: 'mediacloud-paper/',
  journal: 'mediacloud-journal/', // 期刊
  tv: 'mediacloud-article-wx/',
  wx: 'mediacloud-article-wx/',
  nis: 'mediacloud-nis/',
  others: 'mediacloud-article-video/article-others-', // 媒体号
  videos: 'mediacloud-article-video/', // 视频号
  planning: 'mediacloud-newsplan/', // 选题策划
  proSource: 'mediacloud-production-source/', //生产库，资产库
  assetArticle: 'mediacloud-production-source/' // 资产稿库
}
const serviceUrl = {
  dep: '/mediax-articleedit',
  origin: '/mediax-articleorigin',
  audit: '/mediax-articleaudit',
  my: '/mediax-articlemy',
  myHandle: '/mediax-articlemy',
  app: '/mediax-articleapp',
  web: '/mediax-articleapp',
  paper: '/mediax-paper',
  journal: '/mediax-journal', // 期刊
  tv: '/mediax-articlewx',
  weibo: '/mediax-articlewx',
  wx: '/mediax-articlewx',
  others: '/mediax-articlevideo', // 媒体号
  videos: '/mediax-articlevideo', // 视频号
  articleWire: '/mediax-wire', // 新华社稿库
  photoWire: '/mediax-wire', // 新华社图片
  planning: '/mediax-newsplan',
  video: '/mediax-video', // 音视频库
  audio: '/mediax-video', // 音视频库
  nisSet: '/mediax-nis',
  discussSet: '/mediax-nis-discuss',
  instruct: '/mediax-repository', // 云端稿库-指令下达
  otherchannel: '/mediax-admin',
  nis: '/mediax-nis',
  adStart: '/mediax-column',
  recommendation: '/mediax-column',
  jointPlanning: '/mediax-repository', // 云端稿库-联合策划
  systemMessages: '/mediax-nis',
  mediaxBatman: '/mediax-batman', // PUGC投稿平台
  rrLog: '/mediax-repository', // 云端稿库-日志审计
  proSource: '/mediax-asset', // 生产库资产库
  assetArticle: '/mediax-asset', // 资产稿库
  nisApplet:"/mediax-articleapp"// 小程序平台
}

/* 新建稿件的action url的前缀（用于列表按钮显示 */
const addKeyWord = {
  dep: 'ArticleEditAdd',
  origin: 'RootArticleAdd',
  audit: 'RootArticleAdd',
  my: 'ArticleEditAdd',
  app: 'ArticleAdd',
  web: 'ArticleAdd',
  paper: '',
  journal: '', // 期刊
  tv: 'TvArticleAdd',
  wx: 'RootArticleAdd',
  planning: 'TopicEditAdd',
  others: 'MoArticleAdd',
  videos: 'VdArticleAdd',
  proSource: 'ArticleAdd' // 生产库资产库
}

/* 新建或修改稿件的action 页面路由的前缀 */
const addKeyUrlWord = {
  origin: 'RootArticleAdd', // √
  audit: 'RootArticleAdd', // √
  dep: 'ArticleAdd', // √
  my: 'ArticleAdd',
  app: 'ArticleAdd', // √
  web: 'ArticleAdd', // √
  paper: 'ArticleAdd', // ? 没有把
  journal: 'ArticleAdd', // 期刊 ? 没有把
  wx: 'ArticleAdd', // √
  planning: 'TopicEditAdd', // √
  others: 'Add', // √
  videos: 'VdArticleAdd', // √
  proSource: 'ArticleAdd', // 生产库资产库
  assetArticle: 'ArticleAdd' // 资产稿库
}
/* 稿件详情页面路由 */
const detailKeyWord = {
  origin: 'root-article-detail', // √
  audit: 'audit-article-detail', // √
  dep: 'articleDetail', // √
  // my: 'ArticleEditAdd',
  my: 'articleDetail',
  app: 'ArticleDetail', // √
  web: 'ArticleDetail', // √
  paper: 'galley-proof-detail',
  journal: 'ArticleDetail', // 期刊 ？
  tv: 'TvArticleDetail', // √
  tvGroup: 'TvArticleDetail', // √
  wx: 'WxArticleDetail', // √
  weibo: 'article-wb-detail', // √
  planning: 'plan-detail', // √
  others: '',
  videos: 'ArticleDetail', // √
  proSource: '',
  assetArticle: 'article-detail'
}

const apiUrl = {
  photo: {
    Edit: 'ImgLibrary'
  },
  proSource: {
    //  生产库资产库
    Edit: 'MediaCloudProductionSourceIndex'
  },
  assetArticle: {
    Edit: 'MediaCloudArticleSourceIndex'
  },
  dep: {
    Edit: 'MediaCloudArticleEdit',
    Config: 'MediaCloudArticleEditConfig',
    Permission: 'MediaCloudArticleEditPermission'
  },
  audit: {
    Edit: 'MediaCloudArticleAuditEdit',
    Config: 'MediaCloudArticleAuditConfig',
    Permission: 'MediaCloudArticleAuditPermission'
  },
  origin: {
    Edit: 'MediaCloudArticleOriginEdit',
    Config: 'MediaCloudArticleOriginConfig',
    Permission: 'MediaCloudArticleOriginPermission'
  },
  my: {
    Edit: 'MediaCloudArticleMyEdit',
    Config: 'MediaCloudArticleMyConfig',
    Permission: 'MediaCloudArticleMyPermission'
  },
  paper: {
    Edit: 'MediaCloudPaperArticleEdit'
  },
  journal: { // 期刊
    Edit: 'MediaCloudJournalArticleEdit'
  },
  app: {
    Edit: 'MediaCloudPublishCenterMobile',
    Permission: 'MediaCloudAppPermission'
  },
  web: {
    Edit: 'MediaCloudPublishCenterWeb',
    Permission: 'MediaCloudAppPermission'
  },
  wx: {
    Edit: 'MediaCloudPublishCenterWeixin',
    Permission: 'MediaCloudPublishCenterWeixin'
  },
  wxGroup: {
    Edit: 'MediaCloudPublishCenterWeixin',
    Permission: 'MediaCloudPublishCenterWeixin'
  },
  weibo: {
    Edit: 'MediaCloudPublishCenterWeibo'
  },
  tv: {
    Edit: 'MediaCloudPublishCenterTVArticle',
    Permission: 'MediaCloudPublishCenterTVArticle'
  },
  tvGroup: {
    // 串联稿和电视文稿一样的路由 只能手动传入code判断
    Edit: 'MediaCloudPublishCenterTVGroup'
  },
  others: {
    Edit: 'MediaCloudOthersPortal'
  },
  videos: {
    Edit: 'MediaCloudVideoPortal'
  },
  articleWire: {
    Edit: 'MediaCloundWireTable'
  },
  photoWire: {
    Edit: 'MediaCloundWireTable'
  },
  planning: {
    Edit: 'MediaCloudNewsPlanTopics',
    Permission: 'MediaCloudNewsPlanTopics'
  },
  numpaper: {
    Edit: 'MediaCloudNumRcPaperPage'
  },
  batman: {
    Edit: 'MediacloudReporter'
  }
}

const e5MainName = {
  dep: 'article-edit',
  origin: 'article-root',
  audit: 'article-audit',
  my: 'article-my',
  app: 'mediacloud-publish-center',
  web: 'mediacloud-publish-center',
  paper: 'mediacloud-paper',
  journal: 'article-journal', // 期刊小样 √
  tv: 'article-tv',
  tvGroup: 'article-tv',
  wx: 'article-weixin',
  weibo: 'article-weibo',
  myHandle: 'my-handle',
  videos: 'article-video',
  others: 'article-mo',
  planning: 'plan-topic',
  notice: 'article-my',
  proSource: 'mate-article'
}

const windowPath = () => window.location.pathname

/**
 * 通过获取当前的url路径判断所在的微服务
 * 主要用于公共组件的业务逻辑判断
 *
 * **/

export default {
  // 获取微服务前端路由mod
  getE5MainName: () => {
    let service = Object.keys(services).find((key) => {
      if (windowPath().indexOf(services[key]) > -1) {
        return key
      }
    })
    return e5MainName[service]
  },
  // 新建稿件的action url的前缀
  getAddKeyWord: () => {
    let name = windowPath()
    let service = Object.keys(services).find((key) => {
      if (name.indexOf(services[key]) > -1) {
        return key
      }
    })
    return addKeyWord[service]
  },
  // 新建稿件的action url的前缀
  getAddKeyWordByCode: (appointCode) => {
    return addKeyUrlWord[appointCode]
  },
  // 详情页的action url的前缀
  getDetailKeyWordByCode: (appointCode) => {
    return detailKeyWord[appointCode]
  },
  // 获取微服务接口js文件名ByCODE
  getApiUrlByCode: (fileName, appointCode) => {
    return apiUrl[appointCode][fileName]
  },
  // 获取微服务接口js文件名
  getApiUrl: (fileName, appointName) => {
    let name = ''
    appointName ? (name = appointName) : (name = windowPath())
    let service = Object.keys(services).find((key) => {
      if (name.indexOf(services[key]) > -1) {
        return key
      }
    })
    //apiUrl[service][fileName]  不为空的时候 返回apiUrl[service][fileName]，否则返回空字符
    return apiUrl[service] && apiUrl[service][fileName]
      ? apiUrl[service][fileName]
      : ''
  },
  // 获取微服务接口路由前缀
  // 这里写的不好 appointName/appointCode变成了必填造成了误导 以后想个办法分开
  // 是getServiceUrl的简易写法 可以根据 serviceUrl 的key判断接口路由前半部分
  getServiceUrlByCode: (appointCode) => {
    let service = Object.keys(services).find((key) => {
      if (appointCode.indexOf(key) > -1) {
        return key
      }
    })
    return serviceUrl[service]
  },
  // 获取微服务接口路由前缀
  getServiceUrl: (appointName) => {
    let name = ''
    appointName ? (name = appointName) : (name = windowPath())

    let service = Object.keys(services).find((key) => {
      if (name.indexOf(services[key]) > -1) {
        return key
      }
    })
    return serviceUrl[service]
  },
  // 获取微服务前端定义Code/Key名称（只用于业务逻辑判断
  getService: () => {
    let service = Object.keys(services).find((key) => {
      if (windowPath().indexOf(services[key]) > -1) {
        return key
      }
    })
    return service
  },
  // 根据code 判断除了编辑页面的页面路由
  getOpenCommonPath: (appointName) => {
    let name = appointName ? appointName : windowPath()
    let service = Object.keys(services).find((key) => {
      if (name.indexOf(key) > -1) {
        return key
      }
    })

    return servicesCommonKeyWord[service]
  },

  // 根据code 编辑页面的页面路由
  getOpenPath: (appointName) => {
    let name = appointName ? appointName : this.getService()
    let service = Object.keys(services).find((key) => {
      if (name.indexOf(key) > -1) {
        return key
      }
    })

    return servicesOpenKeyWord[service]
  },
  isDep: () => {
    return windowPath().indexOf(services.dep) > -1 ? true : false
  },
  isOrigin: () => {
    return windowPath().indexOf(services.origin) > -1 ? true : false
  },
  isAudit: () => {
    return windowPath().indexOf(services.audit) > -1 ? true : false
  },
  isMy: () => {
    return windowPath().indexOf(services.my) > -1 ? true : false
  },
  isNotice: () => {
    return windowPath().indexOf(services.notice) > -1 ? true : false
  },
  isApp: () => {
    return windowPath().indexOf(services.app) > -1 ? true : false
  },
  isWeb: () => {
    return windowPath().indexOf(services.web) > -1 ? true : false
  },
  isPaper: () => {
    return windowPath().indexOf(services.paper) > -1 ? true : false
  },
  isRcPaper: () => { // 数字报
    return windowPath().indexOf(services.rcpaper) > -1 ? true : false
  },
  isJournal: () => { // 期刊
    return windowPath().indexOf(services.journal) > -1 ? true : false
  },
  isWx: () => {
    return windowPath().indexOf(services.wx) > -1 ? true : false
  },
  isWeibo: () => {
    return windowPath().indexOf(services.weibo) > -1 ? true : false
  },
  isTv: () => {
    return windowPath().indexOf(services.tv) > -1 ? true : false
  },
  isArticleWire: () => {
    return windowPath().indexOf(services.articleWire) > -1 ? true : false
  },
  isPhotoWire: () => {
    return windowPath().indexOf(services.photoWire) > -1 ? true : false
  },
  isAppSet: () => {
    return windowPath().indexOf(services.appSet) > -1 ? true : false
  },
  isVideos: () => {
    return windowPath().indexOf(services.videos) > -1 ? true : false
  },
  isOthers: () => {
    return windowPath().indexOf(services.others) > -1 ? true : false
  },
  isPlanning: () => {
    return windowPath().indexOf(services.planning) > -1 ? true : false
  },
  isCloud: () => {
    return windowPath().indexOf(services.cloud) > -1 ? true : false
  },
  isProSource: () => {
    return windowPath().indexOf(services.proSource) > -1 ? true : false
  }
}
